// extracted by mini-css-extract-plugin
module.exports = {"moveButton":"styles_moveButton__37jPN","categoryContainer":"styles_categoryContainer__2LiAr"};